import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import GuidesListing from '../../components/GuidesListing';
import { fetchAllGtos_ME } from '../../store/actions/gto';
import { connect } from 'react-redux';

import { allNotifications } from '../../utils/toastify';

const { notifyErrorBottomRight } = allNotifications;

class GtoContainer extends Component {
  state = { error: false };

  notify = message => notifyErrorBottomRight(message);

  fetchAllGtos_ME = () => {
    this.props.fetchAllGtos_ME(this.props.codigoPrestador).catch(() => {
      this.setState({ error: !this.state.error });
      this.notify('Não foi possível trazer a lista de glosa');
    });
  };

  componentDidMount = () => {
    this.fetchAllGtos_ME();
  };

  render() {
    const { gtosList, loading } = this.props;

    return (
      <Fragment>
        <Header class="title-center orange-gradient" name="Guias de Tratamento" />
        <GuidesListing gtosList={gtosList} loading={loading} error={this.state.error} />
      </Fragment>
    );
  }
}

GtoContainer.defaultProps = {
  loading: true
};

GtoContainer.propTypes = {
  codigoPrestador: PropTypes.number.isRequired,
  gtosList: PropTypes.arrayOf(PropTypes.any).isRequired,
  loading: PropTypes.bool
};

const mapStateToProps = store => ({
  loading: store.gto.loading,
  codigoPrestador: store.login.user.codigo,
  gtosList: store.gto.gtosList
});

export default connect(
  mapStateToProps,
  { fetchAllGtos_ME }
)(GtoContainer);
